import { Link } from '~/utils/navigation';
import { Box } from '@comeon/ui';
import styled from 'styled-components';

const StyledBox = styled(Box)`
	cursor: pointer;
`;

const GridWrapper = ({
	to,
	href,
	buttonLink,
	children,
	className,
	gridColumn,
	gridRow,
	linkClassName,
	onClick,
	...rest
}) => {
	if (href && !buttonLink) {
		return (
			<StyledBox gridRow={gridRow} gridColumn={gridColumn} {...rest}>
				<a href={href} className={linkClassName} target="_blank" rel="noopener noreferrer" onClick={onClick}>
					{children}
				</a>
			</StyledBox>
		);
	}
	if (to && !buttonLink) {
		return (
			<StyledBox gridRow={gridRow} gridColumn={gridColumn} {...rest}>
				<Link href={to} className={linkClassName} onClick={onClick}>
					{children}
				</Link>
			</StyledBox>
		);
	}

	return (
		<StyledBox gridRow={gridRow} gridColumn={gridColumn} onClick={onClick} {...rest}>
			{children}
		</StyledBox>
	);
};

export default GridWrapper;
